var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('form',[_c('div',{staticClass:"forms-inputs mb-4"},[_c('span',[_vm._v("Photo")]),_c('input',{class:{'form-control':true},attrs:{"type":"file"},on:{"change":_vm.handlePhotoUpload}})]),_c('button',{on:{"click":function($event){$event.preventDefault();return _vm.onUpdateClicked()}}},[_vm._v("Update Meta")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }